import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function CustomerAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    fetch(`${API}/api/public/customer/google`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => navigate("/account", { replace: true, state: { account: data } }))
      .catch(() => { toast.error("Conectarea cu Google a eșuat"); navigate("/account", { replace: true }); });
  }, [location.hash, navigate]);

  return <div className="min-h-screen bg-[#0A0A0E]" data-testid="customer-auth-callback" />;
}
